import React from "react";
import PropTypes from "prop-types";
import AsyncSelect from "react-select/async";
import classNames from "classnames";
import { IconSearch24 } from "../../Icons/Icons";

import "./autocomplete.scss";

const Autocomplete = ({ className, id, ...rest }) => {
  const classes = classNames("autocomplete-container", className);
  return (
    <div className={classes}>
      <AsyncSelect classNamePrefix="autocomplete" aria-label={id} {...rest} />
      <IconSearch24 className="autocomplete__search-icon" />
    </div>
  );
};

Autocomplete.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onInputChange: PropTypes.func,
};

export default Autocomplete;
